//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  data(){
    return{
      title:'问题类别',
      value1:'问题类别',
      list1: [['云服务器', '网站备案', '域名', '虚拟主机', '账号与财务']],
      value1_1: ['云服务器'],
      imgnum:0,
      dataUrl:[],
      describe:'',
      vps:'',
      vps_psd:'',
      domain:'',
      vhost:'',
      vhost_psd:''
    }
  },
  methods: {
    async handleFileChange () {
      let inputDOM = this.$refs.inputer;
      // 通过DOM取文件数据
      this.file  = inputDOM.files[0];


      /*this.imgPreview(this.file);*/

      if(this.file){
        this.imgnum = this.dataUrl.length +1
        let formData = new window.FormData();
        formData.append('cmd', 'up_img')
        formData.append('gd_img', this.$refs.inputer.files[0])
        this.$http.post('https://api.abeiyun.com/www/gd.php',formData).then(({data})=>{
          if(data.response == 200 ) {
            this.dataUrl.push(data.img_url)
          }
        })
      }

    },
    async submit() {
      let data;
      switch (this.value1_1[0]) {
        case '云服务器':
          data = 'cmd=gd_add'+
            '&gd_type=vps'+
            '&product_value='+ this.vps +
            '&gd_content=' + this.describe +
            '&gd_yw_pwd=' + this.vps_psd +
            '&fujian_1=' + (this.dataUrl.length > 0 ? this.dataUrl[0] : '') +
            '&fujian_2=' + (this.dataUrl.length > 1 ? this.dataUrl[1] : '') +
            '&fujian_3=' + (this.dataUrl.length > 2 ? this.dataUrl[2] : '')
          break
        case '网站备案':
          data = 'cmd=gd_add'+
            '&gd_type=beian'+
            '&gd_content=' + this.describe +
            '&fujian_1=' + (this.dataUrl.length > 0 ? this.dataUrl[0] : '') +
            '&fujian_2=' + (this.dataUrl.length > 1 ? this.dataUrl[1] : '') +
            '&fujian_3=' + (this.dataUrl.length > 2 ? this.dataUrl[2] : '')
          break
        case '域名':
          data = 'cmd=gd_add'+
            '&gd_type=domain'+
            '&product_value='+ this.domain +
            '&gd_content=' + this.describe +
            '&fujian_1=' + (this.dataUrl.length > 0 ? this.dataUrl[0] : '') +
            '&fujian_2=' + (this.dataUrl.length > 1 ? this.dataUrl[1] : '') +
            '&fujian_3=' + (this.dataUrl.length > 2 ? this.dataUrl[2] : '')
          break
        case '虚拟主机':
          data = 'cmd=gd_add'+
            '&gd_type=vhost'+
            '&product_value='+ this.vhost +
            '&gd_content=' + this.describe +
            '&gd_yw_pwd=' + this.vhost_psd +
            '&fujian_1=' + (this.dataUrl.length > 0 ? this.dataUrl[0] : '') +
            '&fujian_2=' + (this.dataUrl.length > 1 ? this.dataUrl[1] : '') +
            '&fujian_3=' + (this.dataUrl.length > 2 ? this.dataUrl[2] : '')
          break
        case '账号与财务':
          data = 'cmd=gd_add'+
            '&gd_type=account'+
            '&gd_content=' + this.describe +
            '&fujian_1=' + (this.dataUrl.length > 0 ? this.dataUrl[0] : '') +
            '&fujian_2=' + (this.dataUrl.length > 1 ? this.dataUrl[1] : '') +
            '&fujian_3=' + (this.dataUrl.length > 2 ? this.dataUrl[2] : '')
          break
      }
      let _this = this
      this.$http.post('https://api.abeiyun.com/www/gd.php',data).then(({data})=>{
        if(data.response == 200 ) {
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
            onHide () {
              _this.$router.push('/user/gongdan')
            }
          })
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
            onHide () {
              _this.$router.push('/user/gongdan')
            }
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/console/workoradd.vue